'use client'

import { Navigation, Pagination, Scrollbar } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { TruncateContent } from '@/_components/ui/truncate-content'
import { IReference } from '@/_types'

import { AReferencesFaceStack } from './components/a-references-face-stack'
import { AReferencesSwiperNav } from './components/a-references-swiper-nav'
import { useReferencesSwiper } from './hooks/useReferencesSwiper'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

interface IProps {
	references: IReference[]
}

const ZReferencesSwiper = ({ references }: IProps) => {
	const {
		activeIndex,
		enableLoop,
		enteringIndex,
		finishEntering,
		handleSlideChange,
		slideDirection,
		textLeftSwiperRef,
		textSwiperSpeed
	} = useReferencesSwiper(references.length)

	return (
		<div className='box_refs block_center wmax1100 mgt-60 mgt-30lg'>
			<div className='box_refs_mid w-[150px]! lg:w-auto!'>
				<div className='swiper-faces-cont'>
					<AReferencesFaceStack
						references={references}
						activeIndex={activeIndex}
						enteringIndex={enteringIndex}
						slideDirection={slideDirection}
						onEnterAnimationEnd={finishEntering}
					/>
				</div>
			</div>

			<div className='box_refs_left'>
				<AReferencesSwiperNav />

				<div className='swiper-text-cont mgt-10 mgt-0lg text_center_lgm'>
					<div
						id='slider-text2'
						className='swiper-container swiper-text swiper-flex slider-custom swiper-carousel'
					>
						<Swiper
							slidesPerView='auto'
							loop={enableLoop}
							allowTouchMove={false}
							speed={textSwiperSpeed}
							onSwiper={swiper => {
								textLeftSwiperRef.current = swiper
							}}
						>
							{references.map(reference => (
								<SwiperSlide key={reference.id}>
									<div className='reverse'>
										<div className='title_h11'>{reference.author}</div>
										<div className='text-base mt-1!'>{reference.summary}</div>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
			</div>

			<div className='box_refs_right'>
				<div className='swiper-text-cont'>
					<div
						id='slider-text1'
						className='swiper-container swiper-text swiper-flex slider-custom swiper-carousel'
					>
						<Swiper
							modules={[Navigation, Pagination, Scrollbar]}
							slidesPerView='auto'
							loop={enableLoop}
							allowTouchMove
							speed={textSwiperSpeed}
							onSlideChange={handleSlideChange}
							navigation={{
								prevEl: '.references-prev',
								nextEl: '.references-next'
							}}
							pagination={{
								el: '.references-pagination',
								clickable: true
							}}
							scrollbar={{
								el: '.slider-custom-scrollbar',
								draggable: true
							}}
							className='!h-fit !min-h-auto references-swiper'
						>
							{references.map(reference => (
								<SwiperSlide key={reference.id} className='justify-center'>
									<div className='show_lgm text_center'>
										<div className='title_h11'>{reference.author}</div>
										<div className='text-base mt-1!'>{reference.summary}</div>
									</div>
									<TruncateContent
										key={reference.id}
										className='truncate_content text-center nobalance text-sm! md:text-base! mt-4 lg:md-0 px-3'
										dataTruncateLength='200'
										dataTruncateShow='Čítať viac...'
										dataTruncateHide='Čítať menej'
									>
										{reference.text.split('\n\n').map((paragraph, index) => (
											<p key={index}>{paragraph}</p>
										))}
									</TruncateContent>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ZReferencesSwiper
